import { Component } from 'react';
import {
  axisBottom,
  type AxisDomain,
  axisLeft,
  axisRight,
  type AxisScale,
  type AxisTimeInterval,
  axisTop,
  select,
} from 'd3';

export const enum AxisOrientation {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT,
}

export type AxisProps = Readonly<{
  scale: AxisScale<AxisDomain>;
  orientation: AxisOrientation;
  tickFormat: (value: AxisDomain, index?: number) => string;
  transform?: string;
  ticks?: number | AxisTimeInterval | null;
  tickValues?: AxisDomain[];
}>;

export class Axis extends Component<AxisProps> {
  private element: SVGGElement | null = null;

  public componentDidMount() {
    this.renderAxis();
  }

  public componentDidUpdate() {
    this.renderAxis();
  }

  public render() {
    const { transform } = this.props;

    return (
      <g
        className="Axis"
        transform={transform}
        ref={(el) => {
          this.element = el;
        }}
      />
    );
  }

  private renderAxis() {
    if (this.element) {
      select(this.element).call(this.createAxis());
    }
  }

  private createAxis() {
    const { scale, ticks, tickValues, tickFormat } = this.props;
    const axis = this.getAxisFn()(scale).tickFormat(tickFormat);

    if (ticks) {
      axis.ticks(ticks);
    } else if (tickValues) {
      axis.tickValues(tickValues);
    }

    return axis;
  }

  private getAxisFn() {
    switch (this.props.orientation) {
      case AxisOrientation.TOP:
        return axisTop;
      case AxisOrientation.RIGHT:
        return axisRight;
      case AxisOrientation.BOTTOM:
        return axisBottom;
      case AxisOrientation.LEFT:
        return axisLeft;
      default:
        throw new Error('Invalid axis orientation');
    }
  }
}
